<template>
  <location :child-id="id" />
</template>

<script>
  import Location from '@/components/Child/ChildTabs/TabLocation/Location.vue'

  export default {
    props: {
      id: {
        required: true
      }
    },

    components: {
      Location
    }
  }
</script>
